import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { apiRequest } from '../../utils/api'
import '../../styles/admin/InquiryBox.css'
import { useAuthStore } from '../../store'
import SaveButton from '../common/SaveButton'
import Alert from '../common/Alert'

const BoardCreateBox = () => {
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [content, setContent] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { user } = useAuthStore()
  const [showAlert, setShowAlert] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => {},
  })
  const location = useLocation()
  const fromTab = location.state?.fromTab || 'center'

  const handleSubmit = async () => {
    if (!title.trim()) {
      setShowAlert({
        isOpen: true,
        title: 'Input Error',
        message: 'Please enter a title..',
        onConfirm: () => setShowAlert((prev) => ({ ...prev, isOpen: false })),
      })
      return
    }

    if (!content.trim()) {
      setShowAlert({
        isOpen: true,
        title: 'Input Error',
        message: 'Please enter content..',
        onConfirm: () => setShowAlert((prev) => ({ ...prev, isOpen: false })),
      })
      return
    }

    setIsSubmitting(true)
    try {
      await apiRequest('/board/create', 'POST', {
        TITLE:title,
        CONTENT:content,
        SENDER_ID: user.USER_ID,
        SENDER_ROLE: user.STATUS,
        CENTER_ID : user.CENTER_ID,
        RECEIVER_ROLE : fromTab === 'center' ? 'A' : 'M',
      })

      setShowAlert({
        isOpen: true,
        title: 'Submit Inquiry',
        message: 'Your inquiry has been successfully submitted.',
        onConfirm: () => {
          setShowAlert((prev) => ({ ...prev, isOpen: false }))
          navigate('/inquiries', { state: { returnTab: fromTab } })
        },
      })
    } catch (error) {
      console.error('Failed to submit your inquiry.:', error)
      setShowAlert({
        isOpen: true,
        title: 'Registration failed.',
        message: 'An error occurred while submitting your inquiry. Please try again.',
        onConfirm: () => setShowAlert((prev) => ({ ...prev, isOpen: false })),
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleCancel = () => {
    if (title.trim() || content.trim()) {
      setShowAlert({
        isOpen: true,
        title: 'Discard',
        message: 'You have unsaved changes. Are you sure you want to discard them?',
        onConfirm: () => {
          setShowAlert((prev) => ({ ...prev, isOpen: false }))
          navigate('/inquiries', { state: { returnTab: fromTab } })
        },
      })
    } else {
      navigate('/inquiries', { state: { returnTab: fromTab } })
    }
  }

  return (
    <div className="board-detail">
      <div className="board-header-buttons">
        <SaveButton onClick={handleCancel}>Cancel</SaveButton>
        <SaveButton onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'Registering...' : 'Submit'}
        </SaveButton>
      </div>

      <table className="inquiry-table2">
        <colgroup>
          <col width="15%" />
          <col width="35%" />
          <col width="15%" />
          <col width="35%" />
        </colgroup>
        <tbody>
          <tr>
            <th>Title</th>
            <td>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Please enter a subject for your inquiry."
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ddd',
                }}
              />
            </td>
            <th>Customer Type</th>
            <td>{user.STATUS === 'A' ? 'ADMIN' : 'USER'}</td>
          </tr>
          <tr>
            <th>Date Created</th>
            <td>{new Date().toLocaleDateString('ko-KR')}</td>
            <th>Author</th>
            <td>{user.NAME}</td>
          </tr>
          <tr>
            <th>Content</th>
            <td colSpan={3} className="content-cell">
              <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="Please enter your inquiry."
                rows={15}
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ddd',
                  resize: 'vertical',
                  minHeight: '200px',
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>

      <Alert
        isOpen={showAlert.isOpen}
        onClose={() => setShowAlert((prev) => ({ ...prev, isOpen: false }))}
        title={showAlert.title}
        message={showAlert.message}
        confirmText="Confirm"
        cancelText="Cancel"
        onConfirm={showAlert.onConfirm}
        confirmColor="#007bff"
        showCancel={showAlert.title === 'Cancel'}
      />
    </div>
  )
}

export default BoardCreateBox
